<h2 class="text-muted text-xs-center">Booking Financials</h2>
<hr>

<div class="card flex flex-row flex-wrap gap-3">
  <label class="d-flex align-items-center fw-bold">From</label>
  <p-calendar [(ngModel)]="from" />
  <label class="d-flex align-items-center fw-bold">To</label>
  <p-calendar [(ngModel)]="to" />
  <p-button icon="pi pi-search" [raised]="true" [loading]="loading" [disabled]="loading" (click)="load()" label="Search" styleClass="p-button-outlined"/>
</div>

<p-messages *ngIf="errorMessage" [(value)]="errorMessage" [closable]="false" />

<div class="card" *ngIf="statistic">
  <h4 class="text-muted text-xs-center"></h4>
  <table class="table table-hover">
    <thead class="grey-colour">
    <tr>
      <th>Stat</th>
      <th>Amount</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let reason of array, let i = index;">
      <td>{{ reason[0] }}</td>
      <td>{{ reason[1] }}</td>
    </tr>
    </tbody>
  </table>
</div>

<div class="card" *ngIf="statistic">
  <h4 class="text-muted text-xs-center"></h4>
  <table class="table table-hover">
    <thead class="grey-colour">
    <tr>
      <th>Type</th>
      <th>Amount</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let reason of spendingReasons, let i = index;">
      <td>{{ reason[0] }}</td>
      <td>${{ reason[1] }}</td>
    </tr>
    </tbody>
  </table>
</div>
